export default "__VITE_ASSET__CngCzEKd__"